import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="top-bar">
        <div className="top-bar-left">
          <span>USD</span>
        </div>
        <div className="top-bar-center">
          <p>THE OUTDOOR SALE - SAVE UP TO 25%</p>
        </div>
      </div>
      <div className="main-header">
        <div className="main-header-left">
          <i className="fas fa-search"></i>
          <span>Search</span>
        </div>
        <div className="main-header-center">
          <Link onClick={toTop} to="/">
            Denowl
          </Link>
        </div>
        <div className="main-header-right">
          <Link onClick={toTop} to="/cartpage" className="cart-link">
            <i className="fas fa-shopping-bag"></i>
            {cartItems.length > 0 && (
              <span className="cart-count">{cartItems.length}</span>
            )}
          </Link>
        </div>
      </div>
      <nav className="bottom-nav">
        <Link onClick={toTop} to="/shop">
          New Arrivals
        </Link>
        <Link onClick={toTop} to="/about">
          Our Story
        </Link>
        <Link onClick={toTop} to="/contact">
          Contact Us
        </Link>
      </nav>
    </header>
  );
}

export default Header;
